"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const async_1 = __importDefault(require("react-select/async"));
const react_i18next_1 = require("react-i18next");
const useGooglePlacesService_1 = __importDefault(require("./hooks/useGooglePlacesService"));
const useGooglePlacesFetchSuggestions_1 = __importDefault(require("./hooks/useGooglePlacesFetchSuggestions"));
const googlePlacesAutocompleteRequest_1 = require("./models/googlePlaces/googlePlacesAutocompleteRequest");
const constants_1 = require("../../constants");
const DEFAULT_DEBOUNCE = 500;
const DEFAULT_MIN_LENGTH_AUTOCOMPLETE = 0;
const DEFAULT_ON_LOAD_FAIL = console.error;
const DEFAULT_COLOR = "black";
function GoogleAddressAutocomplete(props) {
    const { apiKey, preferedLanguage, authorizedCountries, handleAddressChange, clearAllFormData, initialAddressPlaceholder, customStyles, customThemeColors, debounce, minLengthAutocomplete, onLoadFail, onBlur, } = props;
    const [selectedOption, setSelectedOption] = (0, react_1.useState)();
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.GOOGLE_ADDRESS_AUTOCOMPLETE_NAMESPACE);
    const firstUpdate = (0, react_1.useRef)(true);
    (0, react_1.useLayoutEffect)(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        clearAllFormData();
        setSelectedOption(undefined);
    }, [authorizedCountries]);
    const { placesService, sessionToken, setSessionToken } = (0, useGooglePlacesService_1.default)({
        apiKey: apiKey,
        apiOptions: {
            language: preferedLanguage,
        },
        onLoadFailed: onLoadFail !== null && onLoadFail !== void 0 ? onLoadFail : DEFAULT_ON_LOAD_FAIL,
    });
    const fetchSuggestions = (0, useGooglePlacesFetchSuggestions_1.default)({
        autocompletionRequest: {
            types: [googlePlacesAutocompleteRequest_1.GooglePlacesAutocompleteResultsTypes.Address],
            componentRestrictions: { country: authorizedCountries },
        },
        debounce: debounce !== null && debounce !== void 0 ? debounce : DEFAULT_DEBOUNCE,
        minLengthAutocomplete: minLengthAutocomplete !== null && minLengthAutocomplete !== void 0 ? minLengthAutocomplete : DEFAULT_MIN_LENGTH_AUTOCOMPLETE,
        placesService,
        sessionToken,
    });
    const getPlacesDetails = (addressChoice) => {
        new google.maps.places.PlacesService(document.getElementById("googlemaps-attribution-container")).getDetails({
            placeId: addressChoice === null || addressChoice === void 0 ? void 0 : addressChoice.value.place_id,
            fields: ["address_components", "formatted_address"],
            sessionToken,
        }, (googlePlaceResult, requestStatus) => {
            setSessionToken(new google.maps.places.AutocompleteSessionToken());
            if (requestStatus === google.maps.places.PlacesServiceStatus.OK) {
                console.log("Google result");
                console.log(googlePlaceResult);
                const convertedAddress = convertPlaceToAddress(googlePlaceResult);
                handleAddressChange(convertedAddress);
            }
            else {
                console.log("Unable to get place details ...");
            }
        });
    };
    const getAddressObject = (address_components) => {
        const TYPES = {
            streetNumber: ["street_number"],
            suiteNumber: ["subpremise"],
            postalCode: ["postal_code"],
            street: ["street_address", "route"],
            region: [
                "administrative_area_level_1",
                "administrative_area_level_2",
                "administrative_area_level_3",
                "administrative_area_level_4",
                "administrative_area_level_5",
            ],
            city: [
                "locality",
                "sublocality",
                "sublocality_level_1",
                "sublocality_level_2",
                "sublocality_level_3",
                "sublocality_level_4",
                "neighborhood",
            ],
            country: ["country"],
        };
        const address = {
            streetNumber: undefined,
            suiteNumber: undefined,
            postalCode: undefined,
            street: undefined,
            region: undefined,
            city: undefined,
            country: undefined,
        };
        address_components === null || address_components === void 0 ? void 0 : address_components.forEach((address_component_item) => {
            for (const type in TYPES) {
                if (TYPES[type].indexOf(address_component_item.types[0]) !== -1) {
                    address[type] = address_component_item;
                }
            }
        });
        return address;
    };
    const convertPlaceToAddress = (place) => {
        var _a, _b, _c, _d;
        const decomposedAddress = getAddressObject(place === null || place === void 0 ? void 0 : place.address_components);
        const newAddress = {
            formattedAddress: place === null || place === void 0 ? void 0 : place.formatted_address,
            streetNumber: (_a = decomposedAddress.streetNumber) === null || _a === void 0 ? void 0 : _a.long_name,
            suiteNumber: (_b = decomposedAddress.suiteNumber) === null || _b === void 0 ? void 0 : _b.long_name.replace(/[^0-9]/g, ""),
            route: decomposedAddress.street,
            city: (_c = decomposedAddress.city) === null || _c === void 0 ? void 0 : _c.long_name,
            country: decomposedAddress.country,
            region: decomposedAddress.region,
            postalCode: (_d = decomposedAddress.postalCode) === null || _d === void 0 ? void 0 : _d.long_name,
        };
        return newAddress;
    };
    const defaultHeight = "45px";
    const defaultStyles = {
        control: (provided) => (Object.assign(Object.assign({}, provided), { background: "white", height: defaultHeight, boxShadow: null, textAlign: "left" })),
        valueContainer: (provided) => (Object.assign(Object.assign({}, provided), { height: defaultHeight, padding: "5px" })),
        input: (provided) => (Object.assign(Object.assign({}, provided), { margin: "0px", color: DEFAULT_COLOR })),
        placeholder: (provided) => (Object.assign(Object.assign({}, provided), { margin: "0px", color: DEFAULT_COLOR })),
        indicatorSeparator: () => ({
            display: "none",
        }),
        indicatorsContainer: (provided) => (Object.assign(Object.assign({}, provided), { height: defaultHeight })),
        menu: (provided) => (Object.assign(Object.assign({}, provided), { margin: "0px", backgroundColor: "white" })),
        option: (provided) => (Object.assign(Object.assign({}, provided), { color: DEFAULT_COLOR })),
        menuPortal: (base) => (Object.assign(Object.assign({}, base), { zIndex: 9999 })),
    };
    const theme = (theme) => (Object.assign(Object.assign({}, theme), { colors: Object.assign({ neutral40: DEFAULT_COLOR, neutral30: DEFAULT_COLOR, neutral20: DEFAULT_COLOR, primary: DEFAULT_COLOR }, customThemeColors) }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "googlemaps-attribution-container", style: { display: "none" } }),
        react_1.default.createElement(async_1.default, { value: selectedOption, placeholder: initialAddressPlaceholder !== null && initialAddressPlaceholder !== void 0 ? initialAddressPlaceholder : t("placeholder"), loadingMessage: () => t("loading"), noOptionsMessage: () => t("no-result"), onChange: (option) => {
                getPlacesDetails(option);
                setSelectedOption(option);
            }, loadOptions: fetchSuggestions, getOptionValue: ({ value }) => value === null || value === void 0 ? void 0 : value.place_id, styles: customStyles !== null && customStyles !== void 0 ? customStyles : defaultStyles, theme: theme, onBlur: onBlur })));
}
exports.default = GoogleAddressAutocomplete;
//# sourceMappingURL=GoogleAddressAutocomplete.js.map